var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0195 18.02C10.4795 18.61 11.1995 19 11.9995 19C13.3795 19 14.4995 17.88 14.4995 16.5C14.4995 15.93 14.3095 15.4 13.9895 14.98",
    stroke: "#27AE60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82 21.3C2.21 20.54 2 19.33 2 17.5L2 15.5C2 11.5 3 10.5 7 10.5L17 10.5C17.36 10.5 17.69 10.51 18 10.53C21.17 10.71 22 11.86 22 15.5L22 17.5C22 21.5 21 22.5 17 22.5L7 22.5C6.64 22.5 6.31 22.49 6 22.47",
    stroke: "#27AE60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.5L6 8.5C6 5.19 7 2.5 12 2.5C16.15 2.5 17.54 3.88 17.9 6.06",
    stroke: "#27AE60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2.5L2 22.5",
    stroke: "#27AE60",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.2881a53258ccf4d09dc2c555cea2c24f.svg";
export { ForwardRef as ReactComponent };